var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Component, Output, EventEmitter, ViewChild } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { UsuarioService } from '../../services/usuario.service';
import { CommonService } from '../../services/common.service';
import { KeycloakService } from '../../services/keycloak.service';
import { AutocompleteComponent } from '../../common/autocomplete/autocomplete.component';
import { AutoCompleteConfig } from '../../common/autocomplete/autocomplete.config';
import { TasasService } from '../../services/tasas.service';
import { ComprobantePopupComponent } from './comprobante-popup.component';
var TasasPopupComponent = (function () {
    function TasasPopupComponent(_usrService, _tService, builder, _comService, _service) {
        this._usrService = _usrService;
        this._tService = _tService;
        this.builder = builder;
        this._comService = _comService;
        this._service = _service;
        this.onClose = new EventEmitter(false);
        this.onRefresh = new EventEmitter(false);
        this.visible = false;
        this.tipo = { id: 0, descr: "Tipo de tasa", tipo: 0, valor: "" };
        this.esModoAlta = true;
        this.tasa = { descripcion: "", fecha: "", importe: "", estado: "", fechaVto: "", fechaHecho: "", rep_codigo: "", fechaPago: "", tipo: null, valor: "", complemento: "", multa: "", determinada: "", monto: "", montoI: "", expediente: this.expediente };
        this.labelImprimir = 'Generar';
        this.labelCancelar = 'Cancelar';
        this.isDisabled = false;
        this.dataArray = [];
        this.minCharsForSearch = 1;
        this.placeholder = 'Tipo de Tasa'; //min amount of chars before autocomplete mayches results
        this.responseApiKey = 'id'; //a reference to the key for example api response [{"id":1,"name":"USA"}, {..}]
        this.responseApiText = 'descr'; //a reference to the text for example api response [{"id":1,"name":"USA"}, {..}]
        this.instanceId = Math.floor(Math.random() * 1000000);
    }
    TasasPopupComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.hideErrorMsg();
        this.texto = this._service.getTextoTasa();
        this.link = this._service.getLinkTasa();
        this.autocomplete.onItemSelected.subscribe(function (event) { _this.onChangeTasa(_this.autocomplete.selectedItem); /*this.tipo = this.autocomplete.selectedItem*/ });
        this.autocompleteConfigAPISource = new AutoCompleteConfig(this.ttasasList, this.minCharsForSearch, this.placeholder, this.responseApiKey, this.responseApiText);
        this._comService.findTiposTasas().subscribe(function (response) {
            _this.ttasasList = response;
            _this.ttasasList = response.sort(function (a, b) { return a.descr.localeCompare(b.descr); });
            _this.autocomplete.setDataSource(_this.ttasasList);
        });
    };
    TasasPopupComponent.prototype.newTasa = function (exp) {
        this.expediente = exp;
        if (this.expediente.fechaHecho == null) {
            var date = new Date();
            this.expediente.fechaHecho = ('0' + date.getDate()).slice(-2) + '/' + ('0' + (date.getMonth() + 1)).slice(-2) + '/' + date.getFullYear();
        }
        this.fechah = this.expediente.fechaHecho;
        this.newTasaExp();
    };
    TasasPopupComponent.prototype.newTasaExp = function () {
        this.hideErrorMsg();
        this.visible = true;
        this.autocomplete.clear();
        this.titulo = 'TASAS JUDICIALES';
        this.subtitulo = 'Complete los datos para generar la tasa judicial y el cupón de pago';
        this.tipo = { id: 0, descr: 'Tipo de tasa', tipo: 0, valor: '' };
        this.tasa = { descripcion: "", fecha: "", importe: "", estado: "", fechaVto: "", fechaHecho: this.fechah, rep_codigo: "", fechaPago: "", tipo: null, valor: "", complemento: "", multa: "", determinada: "", monto: this.expediente.monto, montoI: "", expediente: this.expediente };
    };
    TasasPopupComponent.prototype.finalize = function () {
        if (this.tasa.monto != this.expediente.monto && this.labelCancelar == 'Finalizar') {
            this.onRefresh.emit(this.tasa.monto);
        }
        this.visible = false;
        this.tipo = { id: 0, descr: 'Tipo de tasa', tipo: 0, valor: '' };
        this.tasa = { descripcion: "", fecha: "", importe: "", estado: "", fechaVto: "", fechaHecho: "", rep_codigo: "", fechaPago: "", tipo: null, valor: "", complemento: "", multa: "", determinada: "", monto: this.expediente.monto, montoI: "", expediente: this.expediente, id: null };
        this.hideErrorMsg();
    };
    TasasPopupComponent.prototype.onClickSave = function () {
        var _this = this;
        if (this.labelImprimir === 'Generar') {
            // generar
            if (this.SuccessMessageIsVisible) {
                return;
            }
            this.hideErrorMsg();
            //console.log('GENERAR');
            if (this.validate()) {
                this._comService.emitBlocking(true);
                this.tasa.rep_codigo = KeycloakService.usr.codRep;
                this._tService.insert(JSON.stringify(this.tasa)).subscribe(function (response) {
                    _this._comService.emitBlocking(false);
                    _this.tasa.id = response;
                    _this.isDisabled = true;
                    _this.showSuccessMessage('La Tasa se ingreso correctamente');
                    _this.labelCancelar = 'Finalizar';
                    _this.labelImprimir = 'Imprimir';
                    // document.getElementById("_printButton").hidden = true;
                }, function (error) {
                    _this._comService.emitBlocking(false);
                    _this.showErrorMessage('No se pudo generar la tasa');
                });
            }
        }
        else {
            // imprimir
            //console.log('IMPRIMIR');
            this._comService.emitBlocking(true);
            var fileName_1 = 'comprobante_tasa' + this.expediente.numero + '.pdf';
            var a_1 = document.createElement('a');
            document.body.appendChild(a_1);
            this._tService.reimprimir(JSON.stringify(this.tasa)).subscribe(function (response) {
                _this._comService.emitBlocking(false);
                var file = new Blob([response], { type: 'application/pdf' });
                var fileURL = window.URL.createObjectURL(file);
                a_1.href = fileURL;
                a_1.download = fileName_1;
                a_1.click();
                // this.isDisabled = true;
                // this.showSuccessMessage("La Tasa se ingreso correctamente");
                _this.labelCancelar = 'Finalizar';
                // document.getElementById('_printButton').hidden = true;
            }, function (error) {
                _this._comService.emitBlocking(false);
                _this.showErrorMessage('No se pudo generar el Comprobante');
            });
        }
    };
    TasasPopupComponent.prototype.onClickCancelar = function () {
        this.onClose.emit(1);
    };
    TasasPopupComponent.prototype.onChangeTasa = function (selected) {
        this.tasa.tipo = selected;
        this.reloadMonto();
    };
    TasasPopupComponent.prototype.reloadMonto = function () {
        if (this.tasa.tipo != null) {
            if (this.tasa.tipo.tipo === 0) {
                this.tasa.valor = this.tasa.tipo.valor + "%";
                this.tasa.determinada = ((parseFloat(this.tasa.monto) * parseFloat(this.tasa.tipo.valor)) / 100).toFixed(2);
            }
            else {
                this.tasa.valor = "$" + this.tasa.tipo.valor;
                this.tasa.determinada = this.tasa.tipo.valor;
            }
        }
        this.setTwoNumberDecimal();
    };
    TasasPopupComponent.prototype._keyPress = function (event) {
        var pattern = /[\-+]/;
        var inputChar = String.fromCharCode(event.charCode);
        if ((event.charCode != 0 && pattern.test(inputChar)) || event.charCode == 101) {
            event.preventDefault();
        }
    };
    TasasPopupComponent.prototype._keyPressNeg = function (event) {
        var pattern = /[\+]/;
        var inputChar = String.fromCharCode(event.charCode);
        if ((event.charCode != 0 && pattern.test(inputChar)) || event.charCode == 101) {
            event.preventDefault();
        }
    };
    TasasPopupComponent.prototype.setTwoNumberDecimal = function () {
        if (this.tasa.monto !== "" && this.tasa.monto !== "Nan")
            this.tasa.monto = parseFloat(this.tasa.monto).toFixed(2);
        if (this.tasa.multa !== "" && this.tasa.multa !== "Nan")
            this.tasa.multa = parseFloat(this.tasa.multa).toFixed(2);
        if (this.tasa.complemento != "" && this.tasa.complemento !== "Nan")
            this.tasa.complemento = parseFloat(this.tasa.complemento).toFixed(2);
        if (this.tasa.montoI != "" && this.tasa.montoI !== "Nan")
            this.tasa.montoI = parseFloat(this.tasa.montoI).toFixed(2);
        this.tasa.importe = ((this.tasa.multa !== "NaN" && this.tasa.multa !== "" ? parseFloat(this.tasa.multa) : 0) +
            ((this.tasa.complemento !== "NaN" && this.tasa.complemento !== "") ? parseFloat(this.tasa.complemento) : 0) +
            ((this.tasa.montoI !== "NaN" && this.tasa.montoI !== "") ? parseFloat(this.tasa.montoI) : 0) +
            ((this.tasa.determinada !== "NaN" && this.tasa.determinada !== "") ? parseFloat(this.tasa.determinada) : 0)).toString();
        if (this.tasa.importe != "")
            this.tasa.importe = parseFloat(this.tasa.importe).toFixed(2);
    };
    TasasPopupComponent.prototype.validate = function () {
        if (this.tasa.tipo === null) {
            this.showErrorMessage('El Tipo de Tasa no puede ser vacío');
            return false;
        }
        return true;
    };
    TasasPopupComponent.prototype.showErrorMessage = function (msg) {
        this.ErrorMsg = msg;
        this.ErrorMessageIsVisible = true;
    };
    TasasPopupComponent.prototype.showSuccessMessage = function (msg) {
        this.SuccessMsg = msg;
        this.SuccessMessageIsVisible = true;
    };
    TasasPopupComponent.prototype.hideErrorMsg = function () {
        this.labelCancelar = 'Cancelar';
        this.labelImprimir = 'Generar';
        this.isDisabled = false;
        document.getElementById("_printButton").hidden = false;
        this.ErrorMsg = "";
        this.ErrorMessageIsVisible = false;
        this.hideSuccessMsg();
    };
    TasasPopupComponent.prototype.hideSuccessMsg = function () {
        this.SuccessMsg = "";
        this.SuccessMessageIsVisible = false;
    };
    return TasasPopupComponent;
}());
__decorate([
    Output(),
    __metadata("design:type", EventEmitter)
], TasasPopupComponent.prototype, "onClose", void 0);
__decorate([
    Output(),
    __metadata("design:type", EventEmitter)
], TasasPopupComponent.prototype, "onRefresh", void 0);
__decorate([
    ViewChild(AutocompleteComponent),
    __metadata("design:type", AutocompleteComponent)
], TasasPopupComponent.prototype, "autocomplete", void 0);
__decorate([
    ViewChild(ComprobantePopupComponent),
    __metadata("design:type", ComprobantePopupComponent)
], TasasPopupComponent.prototype, "cmpPopup", void 0);
TasasPopupComponent = __decorate([
    Component({
        moduleId: module.id,
        selector: 'tasa-popup',
        templateUrl: 'tasa-popup.component.html',
        styleUrls: ['./tasa-popup.component.css']
    }),
    __metadata("design:paramtypes", [UsuarioService,
        TasasService,
        FormBuilder,
        CommonService,
        CommonService])
], TasasPopupComponent);
export { TasasPopupComponent };
//# sourceMappingURL=tasa-popup.component.js.map